<template>
<v-container>
  <v-layout row wrap align-center>
    <v-flex sm12 md4 class="text-xs-center text-sm-center text-md-right">
      <img width="280" height="280" :src="logo" class="px-4 pb-4" />
    </v-flex>
    <v-flex sm12 md8>
      <h1 class="px-2 display-2 text-xs-center text-sm-center text-md-left"><b>{{ $t('app_name') }}</b></h1>
      <h4 class="px-2 accent--text title mt-3 mt-2 text-xs-center text-sm-center text-md-left">{{ $t('introduce.slogan') }}</h4>
      <v-container class="px-0 text-xs-center text-sm-center text-md-left">
        <v-btn round outline class="secondary--text" to="/documents">{{ $t('introduce.tutorial') }}</v-btn>
        <v-btn round outline class="secondary--text" to="/settings">{{ $t('introduce.get_token') }}</v-btn>
      </v-container>
    </v-flex>
  </v-layout>
  <v-layout row wrap justify-center>
    <v-flex xs12 sm6 md5>
      <v-card class="mx-4 my-2 elevation-8 text-xs-center">
        <v-icon size="96" color="grey" class="mt-4">pool</v-icon>
        <v-card-text>
          <p class="title accent--text">{{ $t('introduce.real_time_streaming') }}</p>
          <p class="grey--text">{{ $t('introduce.real_time_streaming_description') }}</p>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md5>
      <v-card class="mx-4 my-2 elevation-8 text-xs-center">
        <v-icon size="96" color="grey" class="mt-4">golf_course</v-icon>
        <v-card-text>
          <p class="title accent--text">{{ $t('introduce.one_stop_service') }}</p>
          <p class="grey--text">{{ $t('introduce.one_stop_service_description') }}</p>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>

  <p class="my-4"></p>

  <v-layout row justify-center class="pt-4">
    <v-btn flat color="grey">{{ $t('introduce.terms') }}</v-btn>
    <v-btn flat color="grey">{{ $t('introduce.privacy') }}</v-btn>
    <v-btn flat @click="gotoSupport" color="grey">{{ $t('introduce.support') }}</v-btn>
  </v-layout>

</v-container>
</template>

<script>
import {
  LogoIcons
} from 'luffanet-web-components'

export default {
  name: 'Introduce',
  data(){
    return {
      logo: LogoIcons.large
    }
  },
  methods: {
    gotoSupport() {
      window.open('https://luffanet.freshdesk.com/support/home', '_blank');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/introduce.vue